var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";
import { SignalWatcher } from "@lit-labs/preact-signals";
import { draft } from "../state";
let SaveIndicator = class SaveIndicator extends SignalWatcher(LitElement) {
    static { this.styles = css `
    :host { display: inline-block; font-size: 13px; color: var(--color-slate-500); }
    .err { color: var(--color-red-500); }
    .ok { color: var(--color-green-500); }
  `; }
    render() {
        const d = draft.value;
        if (!d)
            return html ``;
        switch (d.saveStatus) {
            case "saving": return html `<span>Saving…</span>`;
            case "saved":
                return html `<span class="ok">Saved${d.lastSavedAt ? ` ${this.relative(d.lastSavedAt)}` : ""}</span>`;
            case "error":
                return html `<span class="err" role="alert">Save failed. Retry.</span>`;
            default: return html `<span>Unsaved changes</span>`;
        }
    }
    relative(iso) {
        const diffMs = Date.now() - new Date(iso).getTime();
        const mins = Math.round(diffMs / 60_000);
        if (mins < 1)
            return "just now";
        if (mins < 60)
            return `${mins}m ago`;
        return new Date(iso).toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit" });
    }
};
SaveIndicator = __decorate([
    customElement("save-indicator")
], SaveIndicator);
export { SaveIndicator };
